<template>
  <div>
    Display Hardware Setup Here...
  </div>
</template>

<script>
export default {
  name: 'Hardware',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
